module.exports = __webpack_public_path__ + "static/media/pig-cover.a37e7bc7.png";